<template>
  <div class="custom-page-content" :class="brandClass()">
    <slot></slot>
  </div>
</template>

<script>
export default {
  inject:[ 'brandClass'],
  name: 'CustomPageContent',
}
</script>

<style lang="scss">

  .custom-page-content{
    width: 100%;
    padding: 88px 128px 0;
    text-align: left;
    .form {
      margin-top: 22px;
    }
    .mandatory {
      margin-top: 20px;
      font-size: 12px;
      color: $grey2;
    }
    &.__m{
      .mandatory{
        font-family: MINISansSerif;
        color: black;
      }
    }
    &.__t{
      .mandatory{
        font-family: ToyotaSemibold;
        color: black;
      }
    }
    .checkbox-container{
      p{
        a{
          font-weight: bold;
        }
      }
    }
    @media screen and (max-width: 1024px) {
      padding: 80px 80px 0;
    }

    @media screen and (max-width: 768px) {
      width: 427px;        
      padding: 48px 0 0;
      margin: 0 auto;
    }
    @media screen and (max-width: 480px) {
      width: auto;
      margin-left: 24px;
      margin-right: 24px; 
    }
  }

</style>
